import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './analytics';
import { useSEO } from './seo';

/**
 * Custom hook to track page views in Google Analytics
 * Automatically tracks when route changes and updates SEO
 */
export const usePageTracking = () => {
  const location = useLocation();

  // Set SEO meta tags
  useSEO(location.pathname);

  useEffect(() => {
    // Get page title from document or generate from path
    const pageTitle = document.title || generatePageTitle(location.pathname);
    
    // Track the page view
    trackPageView(location.pathname, pageTitle);
  }, [location]);
};

/**
 * Generate a readable page title from the pathname
 * @param {string} pathname - The URL pathname
 * @returns {string} - A formatted page title
 */
const generatePageTitle = (pathname) => {
  const pathMap = {
    '/': 'Dashboard | Tally',
    '/login': 'Log In | Tally',
    '/signup': 'Sign Up | Tally',
    '/dashboard': 'Dashboard | Tally',
    '/pricing': 'Pricing | Tally',
    '/transactions': 'Transactions | Tally',
    '/budget': 'Budget | Tally',
    '/bills': 'Bills | Tally',
    '/plan': 'Monthly Plan | Tally',
    '/insights': 'Insights | Tally',
    '/goals': 'Financial Goals | Tally',
    '/net-worth': 'Net Worth | Tally',
    '/courses': 'Courses | Tally',
    '/settings': 'Settings | Tally',
    '/cash-flow': 'Cash Flow | Tally',
    '/debt': 'Debt Payoff | Tally',
    '/onboarding': 'Onboarding | Tally',
    '/admin': 'Admin Panel | Tally',
    '/privacy': 'Privacy Policy | Tally',
    '/terms': 'Terms of Service | Tally',
    '/welcome': 'Tally | Canadian Budgeting App',
    '/articles': 'Budgeting Tips & Guides for Canadians | Tally Blog',
    '/affiliates': 'Earn Money Promoting Tally | Affiliate Program',
    '/affiliates/login': 'Affiliate Login | Tally',
    '/affiliates/dashboard': 'Affiliate Dashboard | Tally',
    '/docs': 'Help & Documentation | Tally'
  };
  
  return pathMap[pathname] || `${pathname.replace(/\//g, ' ').trim()} | Tally`;
};

export default usePageTracking;
